/**
 * @author taoWu
 * @description 考试身份验证记录
 * @Date 2022/10/11
 */
import React from 'react';
import {connect} from 'dva';
import {templateConfig, reduxTemplateCofig} from './config';
import { examPersonAuthExcelColumns } from './excelColumns';
import {framework_tool, component_tool, utils_tool} from '@/tool'

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs, WizSpin, WizCol, WizRow,WizModal} = component_tool;
let {checkStrLength, Session} = utils_tool;
import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmm') : '';
}
const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const formatterExamType = (val) => {
  let newVal;
  switch (val) {
    case 0 :
      newVal = '独立考试'
      break;
    case 1 :
      newVal = '课程考试'
      break;
    case 3 :
      newVal = ''
      break;
  }
  return newVal;
}
const formatterStatus = (val) => {
  let newVal;
  switch (val) {
    case 0 :
      newVal = '考试进行中'
      break;
    case 1 :
      newVal = '系统审核通过'
      break;
    case 2 :
      newVal = '待审核'
      break;
    case 3 :
      newVal = '审核通过'
      break;
    case 4 :
      newVal = '审核未通过'
      break;
    case 5 :
      newVal = '未认证'
      break;
  }
  return newVal;
}
const formatterJobState = (val) => {
  let newVal = '';
  switch (val) {
    case 0 :
      newVal = '离职'
      break;
    case 1 :
      newVal = '在职'
      break;
    default :  newVal = '';
  }
  return newVal;
}
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/online/examRecord/examPersonAuth') {
      if (history.location && history.location.record && history.location.record.id) {
        record = history.location.record
        Session.set('examAuthInfo', record);
      } else {
        record = Session.get('examAuthInfo') || {}
      }
    }
  }
  return record
}

class ExamPersonAuthManager extends WizContainer {

  componentName = 'ExamPersonAuthManager';

  constructor(props) {
    super(props);
    let initialValue={}
    const {history} = props;
    let record = getParamRecord(history)
    this.state = {
    }
    this.initialValue = record;
  }

  _showTitle(record) {
    let content = <WizCard title={'基本信息'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow>
        <WizCol span={2} offset={1} style={{textAlign: 'right'}}>考试名称： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{record.title}</WizCol>
        <WizCol span={2} style={{textAlign: 'right'}}>考试类型： </WizCol>
        <WizCol span={4} style={{textAlign: 'left'}}>{formatterExamType(record.examType)}</WizCol>
        <WizCol span={3} style={{textAlign: 'right'}}>考试分类： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{record.categoryName}</WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={2} offset={1} style={{textAlign: 'right'}}>考试时间： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{formatterMinute(record.startDate)+' - '+formatterMinute(record.endDate)}</WizCol>
        <WizCol span={2} style={{textAlign: 'right'}}>考试时长： </WizCol>
        <WizCol span={4} style={{textAlign: 'left'}}>{record.limitMinutes != null ? record.limitMinutes + '分钟' : '' }</WizCol>
        <WizCol span={3} style={{textAlign: 'right'}}>通过分数/总分： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{record.passScore+'/'+record.totalScore}</WizCol>
      </WizRow>
    </WizCard>
    return content;
  }


  _handleFile(nextProps, nextState, key) {
    let examName = nextState.params.examName;
    let o = nextProps[key]
    let columnDefs =  examPersonAuthExcelColumns;
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e.examPaperOrder = e.examPaperOrder + '/' + e.count;
        e.status = formatterStatus(e.status);
        e.examDate = formatterDate(e.startDate) + ' - ' + formatterDate(e.endDate);
        e.jobState = formatterJobState(e.jobState);
      })
      let record = Session.get('examAuthInfo') ? Session.get('examAuthInfo') : {};
      let title = '考试名称：' + record.title + '\n'
        + '考试类型：' + formatterExamType(record.examType) + '\n'
        + '考试分类：' + record.categoryName + '\n'
        + '考试时间：' + formatterMinute(record.startDate)+' - '+formatterMinute(record.endDate) + '\n'
        + '考试时长：' + (record.limitMinutes != null ? record.limitMinutes + '分钟' : '') + '\n'
        + '通过分数/总分：' + record.passScore+'/'+record.totalScore;
      let dateTime = formatterDateTime(new Date());
      WizBrowserExport({
        title: title,
        sheetName: '身份验证记录详情',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename:  examName +'_身份验证记录详情_' +dateTime+'.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 105
        }
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let record = this.initialValue;
    const {id} = record;
    let _reduxTemplateCofig = reduxTemplateCofig({
      record,
      templateConfig: templateConfig( id,this,record),
      apiDataFormat: {
        export: this._handleFile
      },
      keepInitApiParams: true,
    })
    return <>{this._showTitle(record)}
      <WizCard title={'身份验证记录'}>
        <WizReduxTemplate {..._reduxTemplateCofig} style={{paddingTop: "100px"}}/>
      </WizCard>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ExamPersonAuthManager);
